import { DynamicFormV2Palette } from "@mui/material";

export type FormRadioSelectComponentTokenType = {
  textColor: string;
  textDisabledColor: string;
  textHoverColor: string;
  textErrorColor: string;
  radioColor: string;
  radioCheckedColor: string;
  radioDisabledColor: string;
  radioHoverColor: string;
  radioFocusColor: string;
  radioErrorColor: string;
  innerCircleColor: string;
  radioBackgroundColor: string;
};

export const assignRadioSelectComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    textColor: formsPalette.text.moderate,
    textDisabledColor: formsPalette.text.moderate,
    textHoverColor: formsPalette.text.moderate,
    textErrorColor: formsPalette.text.error,
    radioColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.intense,
    innerCircleColor: isLightMode ? formsPalette.text.brand : formsPalette.text.intense,
    radioCheckedColor: formsPalette.border.brand,
    radioDisabledColor: formsPalette.border.supershy,
    radioHoverColor: formsPalette.border.brand,
    radioFocusColor: formsPalette.border.quiet,
    radioErrorColor: formsPalette.border.error,
    radioBackgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
  } as FormRadioSelectComponentTokenType;
};
